export default __webpack_public_path__ + "static/media/hertz_24_w.052fa616.svg";